// Typelizer digest b92a8cbe8ed0e1512ed34f0c415fb4a6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /enrollments/new_for_student */
  newForStudent: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/new_for_student', {}, options),
    method: 'get',
  }),

  /** GET /enrollments/created */
  created: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/created', {}, options),
    method: 'get',
  }),

  /** GET /enrollments/canceled */
  canceled: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/canceled', {}, options),
    method: 'get',
  }),

  /** GET /enrollments/confirmed */
  confirmed: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/confirmed', {}, options),
    method: 'get',
  }),

  /** GET /enrollments/comments */
  comments: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/comments', {}, options),
    method: 'get',
  }),

  /** POST /enrollments/send_instructions */
  sendInstructions: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/enrollments/send_instructions', {}, options),
    method: 'post',
  }),

  /** GET /enrollments/:id/cancel_for_student */
  cancelForStudent: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/:id/cancel_for_student', params, options),
    method: 'get',
  }),

  /** GET /enrollments/:id/confirm_for_student */
  confirmForStudent: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/:id/confirm_for_student', params, options),
    method: 'get',
  }),

  /** POST /enrollments/:id/student_confirmation */
  studentConfirmation: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/enrollments/:id/student_confirmation', params, options),
    method: 'post',
  }),

  /** POST /enrollments/:id/backoffice_confirmation */
  backofficeConfirmation: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/enrollments/:id/backoffice_confirmation', params, options),
    method: 'post',
  }),

  /** POST /enrollments/:id/add_payment */
  addPayment: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/enrollments/:id/add_payment', params, options),
    method: 'post',
  }),

  /** PATCH /enrollments/:id/update_diet */
  updateDiet: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/enrollments/:id/update_diet', params, options),
    method: 'patch',
  }),

  /** GET /enrollments */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments', {}, options),
    method: 'get',
  }),

  /** POST /enrollments */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/enrollments', {}, options),
    method: 'post',
  }),

  /** GET /enrollments/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/new', {}, options),
    method: 'get',
  }),

  /** GET /enrollments/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /enrollments/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/enrollments/:id', params, options),
    method: 'get',
  }),

  /** PATCH /enrollments/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/enrollments/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /enrollments/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/enrollments/:id', params, options),
    method: 'delete',
  }),
}
